export function getSearchResults(state, collectionName) {
  const {
    search: { results },
  } = state;
  return results[collectionName] || [];
}
